export const getTimeZoneAbbreviation = (timeZone: string) => {
  return (
    new Intl.DateTimeFormat('en-US', {
      timeZone: timeZone,
      timeZoneName: 'short',
    })
      .formatToParts(new Date())
      .find((part) => part.type == 'timeZoneName') as { value: string }
  ).value;
};
